import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryDeliveryColumn } from '../constants/dictionary-delivery-columns.constant';

export const generateHomeDeliveryInfoColumns = () => {
	return [
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].region,
			dataIndex: 'region',
			key: 'region',
		},
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].commune,
			dataIndex: 'commune',
			key: 'commune',
		},
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].address,
			dataIndex: 'street',
			key: 'street',
		},
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].hometype,
			dataIndex: 'type_house',
			key: 'type_house',
		},
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].floor,
			dataIndex: 'dpto',
			key: 'dpto',
		},
		{
			align:'center',
			title: dictionaryDeliveryColumn[Enviroment.LANGUAGE].reference,
			dataIndex: 'reference',
			key: 'reference',
		},
	];
};
